module.exports = __webpack_public_path__ + "static/discount-2400x1256.7ebfba0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/multimedia/2019/discount-2400x1256.png
// module id = 567
// module chunks = 116596815971312